<template>
  <div class="header">
    <div class="contant">
      <el-dropdown>
        <span class="el-dropdown-link">
          <div class="logoUnit" @click="goTab">
            <img src="../assets/img/2234.svg" class="logo" alt />
            <span class="shuxian">|</span>
            <span class="titleType">传输助手</span>
            <img src="../assets/img/dropDownT.svg" alt class="downIcon" />
          </div>

          <el-dropdown-menu slot="dropdown2">
            <el-dropdown-item>
              <div class="tapItem" @click="switchJiaofu">
                <span>切换至超爽整理工具</span>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </span>
      </el-dropdown>

      <div class="infoList">
        <el-dropdown>
          <span class="el-dropdown-link">
            <div class="userInfo">
              <img :src="userInfo.avatar" alt class="headerImg" />
              <p class="nameNick">{{userInfo.nickname}}</p>
              <img src="../assets/img/dropDownT.svg" alt class="dropDownT" />

              <div class="transfromDiv">
                <!-- <div class="dropDownTap"> -->
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <div class="tapItem" @click="openMask(1)">
                      <img src="../assets/img/qrCode.svg" alt style="margin-right:13px" />
                      <span>我的作品</span>
                    </div>
                  </el-dropdown-item>
                  <!-- <el-dropdown-item>
                    <div class="tapItem" @click="openMask(2)">
                      <img src="../assets/img/feedbackIcon2.svg" alt style="margin-right:13px" />
                      <span>问题反馈</span>
                    </div>
                  </el-dropdown-item> -->
                  <el-dropdown-item>
                    <div class="tapItem" @click="openMask(3)">
                      <img src="../assets/img/exitIcon.svg" alt style="margin-right:13px" />
                      <span>退出</span>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </div>
            </div>
          </span>
        </el-dropdown>

        <div class="line"></div>
        <div class="addProject">
          <input type="file" webkitdirectory multiple @change="addProject($event)" /> 添加项目
        </div>
      </div>
    </div>

    <!-- 退出和二维码的弹窗 -->
    <div class="maskOut" v-if="maskStatus != 0">
      <!-- 退出弹框 -->
      <div class="outMask" v-if="maskStatus == 3">
        <div class="outClose">
          <img src="../assets/img/stepsClose.svg" alt @click="openMask(0)" />
        </div>
        <p class="titleP">是否退出交付工具</p>
        <p class="titleG">你可以在小程序中找到项目</p>
        <div class="btnMoni">
          <div class="noOut" @click="openMask(0)">暂不退出</div>
          <div class="okOut" @click="close">确定退出</div>
        </div>
      </div>

      <!-- 问题反馈二维码弹框 -->
      <div class="qrCodeView" v-if="maskStatus == 2">
        <div class="closeIcon">
          <p>提交反馈</p>
          <img src="../assets/img/stepsClose.svg" alt @click="openMask(0)" />
        </div>
        <div class="qrCodeImg">
          <img :src="problemQrcode" alt />
        </div>
        <p>手机扫码在小程序提交问题反馈</p>
      </div>

      <!-- 我的作品二维码弹框 -->
      <div class="qrCodeView" v-if="maskStatus == 1">
        <div class="closeIcon">
          <p>我的作品</p>
          <img src="../assets/img/stepsClose.svg" alt @click="openMask(0)" />
        </div>
        <div class="qrCodeImg">
          <img :src="xcxQrcode" alt />
        </div>
        <p>手机扫码在小程序查看作品</p>
      </div>
    </div>
  </div>
</template>

<script>
import { xcxQrcode, userInfo } from "@/request/api";
export default {
  name: "headers",
  data() {
    return {
      dropDownTap: false,
      maskStatus: 0, //打开弹窗 0:关闭  1，我的作品   2，提交问题   3，退出
      xcxQrcode: "",
      problemQrcode: "",
      userInfo: {}
    };
  },
  mounted() {
    this.getUserInfo();
  },
  beforeDestroy() {
    [this.xcxQrcode, this.problemQrcode].filter(Boolean).forEach(url => window.URL.revokeObjectURL(url));
  },
  methods: {
    getQrcode(type) {
      const field = type === 1 ? 'xcxQrcode' : 'problemQrcode';
      this._qrPending = this._qrPending || {};
      if (this[field] || this._qrPending[field]) return;
      this._qrPending[field] = true;
      xcxQrcode({ path: type === 1 ? 'pages/homePage/homePage' : 'subPage/feedBack/feedBack', width: type === 1 ? 202 : 280 })
        .then(res => { if (!this._isDestroyed && res && res.status === 200) this[field] = window.URL.createObjectURL(new Blob([res.data])); })
        .catch(() => {})
        .finally(() => { delete this._qrPending[field]; });
    },
    // 有关下拉框的事件
    openMask(e) {
      this.maskStatus = e;
      if (e === 1 || e === 2) this.getQrcode(e);
    },
    // 退出
    close() {

      console.log('close1')

      // this.$router.push({
      //   path: "/"
      // });

      this.$router.push({
        path: "/"
      });
    },

    // 切换交付
    switchJiaofu() {
      var that = this;
      this.$router.push({
        path: "/transferView"
      });
    },

    // 添加项目
    addProject(event) {
      this.$emit("dealWithData", event);
    },
    // 获取个人信息
    getUserInfo() {
      var that = this;
      userInfo().then(res => {
        console.log(res, "个人信息？");
        that.userInfo = res.data.data;
      });
    },

    // 点击Logo,回到tab页
    goTab() {
      this.$router.push({
        path: "/tab"
      });
    }
  }
};
</script>

<style lang="less" scoped>
span {
  font-family: PingFangSC-Semibold, PingFang SC;
}

.header {
  height: 60px;
  background: #fff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  .contant {
    width: 90%;
    min-width: 1000px;
    height: 100%;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logoUnit {
      display: flex;
      align-items: center;
      .logo {
        width: 84px;
        height: 26px;
        display: inline-block;
        vertical-align: middle;
      }

      .shuxian {
        font-size: 16px;
        margin: 0px 10px;
      }

      .titleType {
        font-size: 18px;
      }

      .downIcon {
        vertical-align: middle;
        width: 10px;
        height: 10px;
        margin-left: 10px;
      }
    }

    .infoList {
      display: flex;
      align-items: center;
      .addProject {
        width: 110px;
        height: 36px;
        text-align: center;
        line-height: 36px;
        background: rgba(62, 205, 246, 1);
        color: #ffffff;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        border-radius: 18px;
        position: relative;
        input {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
        }
      }
      .funcItem {
        margin-left: 15px;
        font-size: 12px;
        color: #333333;
      }
      .line {
        width: 1px;
        height: 10px;
        background: rgba(0, 0, 0, 0.1);
        margin-left: 17px;
        margin-right: 17px;
      }
      .userInfo {
        font-size: 12px;
        color: #333333;
        height: 60px;
        display: flex;
        align-items: center;
        position: relative;
        .nameNick {
          width: 20px;
        }
        .headerImg {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          margin-right: 12px;
        }
        .dropDownT {
          margin-left: 5px;
        }
        .transfromDiv {
          .dropDownTap {
            width: 110px;
            height: 112px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.14);
            border-radius: 8px;
            position: absolute;
            left: 0;
            top: 56px;
            padding: 10px 0px 10px 14px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            .tapItem {
              display: flex;
              align-items: center;
              img {
                margin-right: 14px;
              }
            }
          }
        }
      }
      .outDiv {
        font-size: 12px;
        color: #333333;
      }
    }
  }
}

.maskOut {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  z-index: 9999999 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  .outMask {
    width: 378px;
    height: 200px;
    background: #ffffff;
    border-radius: 10px;
    .outClose {
      text-align: right;
      img {
        width: 14px;
        height: 14px;
        margin-right: 20px;
        margin-top: 20px;
      }
    }
    .titleP {
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 25px;
      text-align: center;
      margin-top: 18px;
    }
    .titleG {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      text-align: center;
      margin-top: 11px;
    }
    .btnMoni {
      display: flex;
      justify-content: space-between;
      width: 232px;
      margin: 15px auto 0px;
      .noOut {
        width: 110px;
        height: 36px;
        border-radius: 20px;
        background: rgba(240, 240, 240, 1);
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
      }
      .okOut {
        width: 110px;
        height: 36px;
        border-radius: 20px;
        background: #ec4d3d;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
      }
    }
  }

  .qrCodeView {
    width: 330px;
    height: 394px;
    background: #ffffff;
    border-radius: 10px;
    .closeIcon {
      display: flex;
      justify-content: space-between;
      p {
        margin-left: 20px;
        margin-top: 20px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
      }
      img {
        width: 14px;
        height: 14px;
        margin-right: 20px;
        margin-top: 20px;
      }
    }
    .qrCodeImg {
      width: 202px;
      height: 202px;
      margin: 46px auto 35px;
      background: #000;
      img {
        width: 202px;
        height: 202px;
      }
    }
    p {
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      text-align: center;
    }
  }
}
</style>

